export function collectPages(staticPages, entries) {
  return [...staticPages, ...entries].map((entry) => {
    const baseTitle = entry.title || entry.name;
    const suffix = entry.path.startsWith('/projects/') ? ' | Photo & Video Project | Moyer Production'
      : entry.coverImage && entry.path !== '/restaurant' ? ' | Restaurant Photography | Moyer Production'
      : entries.includes(entry) && !entry.path.startsWith('/blog/') ? ' in Bonney Lake | Moyer Production' : '';
    return {
      ...entry,
      description: (entry.description || entry.excerpt || `Explore ${baseTitle} photography and video work from Moyer Production Co. in Bonney Lake, Washington.`).replace(/\s+/g, ' ').trim().slice(0, 170),
      title: entry.seoTitle || `${baseTitle}${suffix}`,
      image: entry.image || entry.featuredImage || entry.banner || entry.coverImage || entry.heroImage || '/Moyerlogo.png',
    };
  });
}
